import initialState from "./store";
import actions from "./actions";
import reducer from "./reducer";
import { useCallback, useReducer } from "react";
import { ContextProviderProps } from "../context.types";
import GroupContext from "./groupContext";

const GroupContextProvider = ({ children }: ContextProviderProps) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {
		group_number: state.group_number,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		setGroup: useCallback(
			(group_number: number) => dispatch({ type: actions.SET_GROUP_NUMBER, payload: { ...state, group_number } }),
			[]
		)
	};

	return <GroupContext.Provider value={value}>{children}</GroupContext.Provider>;
};

export default GroupContextProvider;
